import { Capacitor } from "@capacitor/core";

/**
 * Opens a link outside the app (App Store, Play Store, store subscription pages).
 *
 * iOS: a top-level navigation is handed to the OS by Capacitor's
 * `WebViewDelegationHandler.decidePolicyFor` (the host is not in
 * `server.allowNavigation`, so it calls `UIApplication.shared.open` and cancels
 * the navigation — the app page stays put). This avoids WKWebView's popup rules
 * that can swallow `window.open`. Do not use `App.openUrl`: it does not exist in
 * `@capacitor/app` and fails silently.
 *
 * Android / web: `window.open` already opens the store app or a new tab.
 */
export const openExternalUrl = (url: string) => {
  if (Capacitor.getPlatform() === "ios") {
    window.location.href = url;
    return;
  }

  window.open(url, "_blank", "noopener,noreferrer");
};
